






















































































































import Vue from 'vue';
import key from '@/libs/filters/key';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { TCommonForm, TLessonCommentInfo } from '@/types/views/educational';
import {
  saveComment,
  sendCommentNotify,
  getLessonComment
} from '@/api/educational';
@Component({
  components: {}
})
export default class Comment extends Vue {
  @Prop({
    type: Object,
    required: true
  })
  user!: any;
  @Prop({
    type: Number,
    default() {
      return 0;
    }
  })
  commentStatus!: Number;
  @Prop({
    type: Number,
    default() {
      return 0;
    }
  })
  commentNotifyStatus!: Number;
  @Prop({
    type: Function,
    required: true
  })
  reload!: Function;

  @Watch('user')
  watchUser(user: any) {
    let len = Object.getOwnPropertyNames(user).length;
    if (len > 0) {
      this.openDialog();
    }
  }
  private key: any = key;
  private dialogVisible = false;
  private questionActives = [
    {
      value: 'A',
      label: 'A-积极回答并每次都可以回答正确(棒棒哒)'
    },
    {
      value: 'B',
      label: 'B-积极回答但偶尔回答错误(非常好)'
    },
    {
      value: 'C',
      label: 'C-不积极回答但大部分都可以回答正确(继续加油)'
    },
    {
      value: 'D',
      label: 'D-从来不回答问题(有待提高哦，加油！)'
    }
  ];
  private teacherActives = [
    {
      value: 'A',
      label: 'A-非常踊跃能积极和老师互动(棒棒哒)'
    },
    {
      value: 'B',
      label: 'B-比较活跃大部分时间能和老师互动(非常好)'
    },
    {
      value: 'C',
      label: 'C-不太踊跃偶尔和老师互动(继续加油)'
    },
    {
      value: 'D',
      label: 'D-全程基本和老师无互动(有待提高哦，加油！)'
    }
  ];
  private shareActives = [
    {
      value: 'A',
      label: 'A-非常主动分享和交流自己的作品(棒棒哒)'
    },
    {
      value: 'B',
      label: 'B-偶尔愿意主动分享和交流自己的作品(非常好)'
    },
    {
      value: 'C',
      label: 'C-被老师选中的时候愿意分享自己的作品(继续加油)'
    },
    {
      value: 'D',
      label: 'D-从不愿意分享和交流自己的作品(有待提高哦，加油！)'
    }
  ];
  private form: TCommonForm = {
    attendStatus: true,
    worksStatus: true,
    teacherActive: 0,
    questionActive: 0,
    shareness: 0,
    onClassworkness: 0,
    afterClassworkness: 0,
    knowledgeness: 0,
    interactionness: 0,
    answerness: 0,
    classComment: '',
    homeworkComment: '',
    innovate: 0,
    performance: 0,
    interest: 0,
    expression: 0,
    interactive: 0,
    projectDegree: 0
  };
  private lessonComment: TLessonCommentInfo = {
    courseName: '',
    lessonName: '',
    realName: '',
    startTime: '',
    attendStatus: '',
    userLesson: {}
  };
  get commonContent() {
    return this.commentStatus ? '已点评' : '未点评';
  }
  get notifyContent() {
    return this.commentNotifyStatus ? '已推送' : '未推送';
  }
  /**
   * @description: 提交表单 - 包含老师点评和推送
   * @param {string} type 是否是推送
   */
  onSubmit(type: string) {
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (valid) {
        const condition: any = {
          ...this.lessonComment.userLesson,
          id: (this.lessonComment.userLesson as any).id,
          attendStatus: (this.lessonComment.userLesson as any).attendStatus
            ? 1
            : 0,
          worksStatus: (this.lessonComment.userLesson as any).worksStatus
            ? 1
            : 0
        };
        delete condition.userLesson;
        delete condition.projects;
        delete condition.createTime;
        delete condition.commentTime;
        delete condition.commentNotifyTime;

        const res = await saveComment(condition);
        if (res.code === '000001') {
          this.$message.success('评论成功');

          if (type && type === '推送') {
            try {
              const data = await sendCommentNotify({
                userLessonId: this.user.userLessonId
              });
              if (data.code === '000001') {
                this.$message.success(data.message);
              }
            } catch (err) {
              this.$message.error(err.message);
            }
          }
          this.dialogVisible = false;
          this.reload && this.reload();
        }
      } else {
        this.$message.error('请将信息填写完整');
      }
    });
  }
  /**
   * @description: 推送老师点评
   */
  async sendCommentNotify() {
    this.onSubmit('推送');
  }
  private async getLesonComment() {
    try {
      this.lessonComment = await getLessonComment({
        userLessonId: this.user.userLessonId || 1
      });
    } catch (e) {
      this.$message.error(e.message);
    }
  }
  private async openDialog() {
    try {
      await this.getLesonComment();
    } catch (e) {
      this.$message.error(e.message);
    }
  }
  private handleClose() {
    this.dialogVisible = false;
  }
}
